/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosError, AxiosRequestConfig } from "axios";
import { $axios, $axiosRefresh } from "./axiosInstance";
import { handleErrorWithRedirect, handleAuthenticationRedirect, getCurrentUrlWithoutContextPath } from "./handler/errorHandler";
import { getCSRFToken } from "./handler/csrfHandler";
import { handleCancellableRequest, handleCancellableResponse } from "./handler/requestCancelHandler";

declare module "axios" {
	interface AxiosRequestConfig {
		handleErrorWithRedirect?: boolean;
	}
}

const setHeaders = (request: AxiosRequestConfig): void => {
	request.headers = request.headers || {};
	request.headers["X-Requested-With"] = "XMLHttpRequest";
	request.headers["getUrl"] = getCurrentUrlWithoutContextPath();
	request.headers["CSRFToken"] = getCSRFToken();
};

const isCancel = axios.isCancel;

$axios.interceptors.request.use((request: AxiosRequestConfig):any => {
	setHeaders(request);
	handleCancellableRequest(request);
	return request;
});

$axios.interceptors.response.use(
	(response) => {
		handleCancellableResponse(response.config?.cancelToken);
		return response;
	},
	(error: AxiosError) => {
		if (axios.isCancel(error)) {
			return Promise.reject(error);
		}
		handleCancellableResponse(error.config?.cancelToken);
		handleAuthenticationRedirect(error);
		handleErrorWithRedirect(error);
		return Promise.reject(error);
	}
);

// handle createAuthRefreshInterceptor refresh response with unauthorized
$axiosRefresh.interceptors.response.use(
	(response) => response,
	(error) => {
		handleAuthenticationRedirect(error);
		return Promise.reject(error);
	}
);

export { $axios, isCancel };
